// src/components/onboarding/OnboardingModal.jsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./OnboardingModal.module.css";

const STEPS = [
  {
    emoji: "🎉",
    title: "Welcome to GigScout",
    body: "You've got 5 free credits to get started. Browse all job listings for free — spend 2 credits to unlock the apply link and contact details for any listing.",
    cta:  "Next",
  },
  {
    emoji: "🎯",
    title: "Personalise your feed",
    body: "Set your province and industry so your job feed shows the most relevant gigs for you. It takes 30 seconds and makes a huge difference.",
    cta:  "Set up my profile",
    ctaSecondary: "Skip for now",
  },
  {
    emoji: "📧",
    title: "Get job alerts by email",
    body: "Once your industry is set, we'll email you automatically when new matching jobs are posted — no push notifications needed.",
    cta:  "Start browsing",
  },
];

const STORAGE_KEY = "gigscout_onboarded_v1";

export default function OnboardingModal() {
  const [step, setStep] = useState(0);
  const navigate = useNavigate();

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, "1");
    // force re-render in parent by dispatching a storage event
    window.dispatchEvent(new Event("storage"));
  };

  const handleCta = () => {
    if (step === 1) {
      dismiss();
      navigate("/profile");
    } else if (step === STEPS.length - 1) {
      dismiss();
    } else {
      setStep(s => s + 1);
    }
  };

  const handleSecondary = () => {
    if (step === 1) setStep(2);
  };

  const current = STEPS[step];

  return (
    <div className={styles.overlay} onClick={(e) => e.target === e.currentTarget && dismiss()}>
      <div className={styles.modal} role="dialog" aria-modal="true">

        <button className={styles.close} onClick={dismiss} aria-label="Dismiss">✕</button>

        <div className={styles.emoji}>{current.emoji}</div>
        <h2 className={styles.title}>{current.title}</h2>
        <p className={styles.body}>{current.body}</p>

        <div className={styles.dots}>
          {STEPS.map((_, i) => (
            <span key={i} className={`${styles.dot} ${i === step ? styles.dotActive : ""}`} />
          ))}
        </div>

        <div className={styles.actions}>
          <button className={styles.cta} onClick={handleCta}>
            {current.cta}
          </button>
          {current.ctaSecondary && (
            <button className={styles.secondary} onClick={handleSecondary}>
              {current.ctaSecondary}
            </button>
          )}
        </div>

      </div>
    </div>
  );
}

export function shouldShowOnboarding() {
  return !localStorage.getItem(STORAGE_KEY);
}
